import { Component, OnInit } from '@angular/core';
import { Class } from './training.model';
import { TrainingService } from './training.service';
import { LoggerService } from 'src/app/logger.service';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-training',
  templateUrl: './training.page.html',
  styleUrls: ['./training.page.scss'],
})
export class TrainingPage implements OnInit {

  public platform ="";

  constructor(private loggerService:LoggerService, public translator:TranslatorService) { }

  ngOnInit() {

  }

  ionViewWillEnter()
  {
    this.platform = this.loggerService.getPlatorm();
  }

}
